<template>
    <div class="flex-1">
        <div class="p-0" style="display: block;" v-if="isPageOpened()">
            <div class="tab-content mt-4">
                <div class="panel">
                    <div class=" reports_container">
                        <h2 v-if="lang=='en'" class="dark-title">System Reports ({{ this.reports.length }})</h2>
                        <h2 v-else class="dark-title font-weight-bold">تقارير النظام ({{ this.reports.length }})</h2>
                        <div class="grid-4-items">
                            <v-card class="" v-for="item in this.reports" :value="item.id" :key="item.id" @click="openReport(item.id)" >
                                <!-- <v-chip dark class="mb-3" color="purple">category</v-chip> -->
                                <h3 v-if="lang=='en'" class="dark-title pb-2">{{ item.titleEn }}</h3>
                                <h3 v-else class="dark-title font-weight-bold pb-2">{{ item.titleAr }}</h3>
                                <p class="m-0" v-if="lang=='en'">{{ item.descriptionEn }}</p>
                                <p class="m-0" v-else>{{ item.descriptionAr }}</p>
                            </v-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants';
import Report from '@/views/Reports/Report.vue'
import router from '@/router/index.js'

export default {
    name: 'Reports',
    components: { Report },
    data: function () {
        return {
            reports: [],
            lang: 'en',
        };
    },
    methods: {
        isPageOpened() 
        {
            return this.$route.name === 'reports'
        },
        getReports() 
        {
            axios.get(constants.baseApiUrl + "Report/GetReports?applicationId="+window.defaultApplicationId, { headers: constants.headers })
                .then((res) => this.reports = res.data)
                .catch((err) => console.log(err));
        },
        openReport: function (reportId) 
        {
            var selectedReport = this.reports.find((obj) => obj.id === reportId);
            if (selectedReport != null) 
            {
                router.push({ name: 'report', query: { id: selectedReport.id} })
            }
        },
    },
    mounted() 
    {
        this.lang = 'en'
        if (localStorage.getItem('lang') != null)
            this.lang = localStorage.getItem('lang')

        const intervalId = setInterval(() => 
        {
            if (constants.isPermissionsLoaded == true) 
            {
                clearInterval(intervalId);
                this.getReports();
            }
        }, 100);
    }
}
</script>

<style scoped>
.v-card {
    box-shadow: 0px 12px 24px rgb(0 0 0 / 8%) !important;
    border: 0;
    border-radius: 12px;
    padding: 1rem;
}
</style>